import { render } from "./ApprenticeListView.vue?vue&type=template&id=f910492c&scoped=true"
import script from "./ApprenticeListView.vue?vue&type=script&lang=js"
export * from "./ApprenticeListView.vue?vue&type=script&lang=js"

import "./ApprenticeListView.vue?vue&type=style&index=0&id=f910492c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f910492c"]])

export default __exports__